<template>
  <div style="margin: 0">
    <!--头部-->
    <div class="head">
      <div class="wrap flex-row">
        <div class="logo flex-row">
          <img v-if="config.web_logo" :src="config.web_logo">
          <h2>{{ config.web_name }}</h2>
        </div>
        <el-input placeholder="请输入内容">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <!--导航-->
    <div class="nav">
      <ul class="wrap flex-row">
        <li @click="toPage(item.url, index)" v-for="(item, index) in menus" :key="index" :class="{active: menuIndex == index}">{{ item.name }}</li>
      </ul>
    </div>
    <!--轮播-->
    <div class="slider">
      <div class="wrap">
        <el-carousel>
          <el-carousel-item v-for="(item, index) in sliders" :key="index">
            <img :src="item.image" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!--主体-->
    <div class="body">
      <router-view></router-view>
    </div>
    <!--底部-->
    <div class="foot">
      <div class="wrap flex-row" style="align-items: flex-start">
        <div>
          <dl class="dtitle">
            <dt>联系我们</dt>
            <dd>CONTACT US</dd>
          </dl>
          <ul>
            <li>
              <i class="el-icon-location-outline"></i>
              <span>{{ config.address }}</span>
            </li>
            <li>
              <i class="el-icon-phone-outline"></i>
              <span>{{ config.phone }}</span>
            </li>
            <li>
              <i class="el-icon-eleme"></i>
              <span>{{ config.email }}</span>
            </li>
            <li>
              <i class="el-icon-printer"></i>
              <span>{{ config.fox }}</span>
            </li>
          </ul>
        </div>
        <div>
          <dl class="dtitle">
            <dt>公司概况</dt>
            <dd>ABOUT US</dd>
          </dl>
          <p v-html="config.summary"></p>
        </div>
      </div>
    </div>
    <!--版权-->
    <div class="copyright">
      <div class="wrap">
        <span>{{ config.copyright }}</span>
        <a href="" class="icp">{{ config.icp }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { COMPANY_NAME,NAV,SLIDER } from 'assets/js/config';
export default {
  data(){
    return {
      config: {},             // 配置参数
      company: COMPANY_NAME,
      menus: NAV,
      sliders: SLIDER,
      menuIndex: 0,
    }
  },
  watch: {
    $route(newVal, oldVal){
      switch(newVal.path){
        case '/': this.menuIndex = 0; break
        case '/news': this.menuIndex = 1; break
        case '/about': this.menuIndex = 2; break
        case '/product': this.menuIndex = 3; break
        case '/industry': this.menuIndex = 4; break
        case '/service': this.menuIndex = 5; break
        case '/partner': this.menuIndex = 6; break
        case '/recruit': this.menuIndex = 7; break
        case '/contact': this.menuIndex = 8; break
      }
    }
  },
  created(){
    this.getConfig()
    this.getSliders()
  },
  methods: {
    // 页面跳转
    toPage(url, index){
      this.menuIndex = index;
      if(url) this.$router.push(url);
    },
    // 获取配置参数
    getConfig(){
      this.$api.getConfig().then(res=>{
        if(res.code == 0){
          this.config = res.data[0]
          this.config.web_logo = this.config.web_logo ? this.$baseURL + this.config.web_logo : ''
          localStorage.setItem('config', JSON.stringify(this.config))
        }
      })
    },
    // 获取轮播
    getSliders(){
      this.$api.getSliders().then(res=>{
        this.sliders = res.data.map(item=>{
          item.image = this.$baseURL + item.image
          return item
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('assets/css/base.css');
$mainColor: #FF4D34;

/* 底部 */
.foot{
  height: 380px;
  color: #ccc;
  padding: 60px 0;
  background: #2A2A2A;
  box-sizing: border-box;
}
.foot .wrap>div{
  width: 50%;
  height: 100%;
}
.foot .dtitle{
  margin-bottom: 40px;
}
.foot ul li{
  margin-bottom: 20px;
}
.foot ul li span{
  font-size: 13px;
  margin-left: 5px;
}
.foot p{
  color: #999;
  font-size: 13px;
  line-height: 2;
}

/* 版权 */
.copyright{
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #222;
  font-size: 13px;
  color: #ccc;
}
.copyright .icp{
  color: #52346C;
  margin-left: 20px;
}

/* 轮播 */
.slider{
  padding: 2px 0 0;
  background: #F9F9F9;
}
.slider .el-carousel,
.slider .el-carousel>>>.el-carousel__container{
  width: 100%;
  height: 460px;
}
.slider .el-carousel img{
  width: 100%;
  height: 100%;
}

/* 导航 */
.nav{
  height: 50px;
  line-height: 50px;
  overflow: hidden;
  border-top: 1px solid #F2F2F2;
  border-bottom: 1px solid #F2F2F2;
}
.nav ul{
  justify-content: flex-start;
}
.nav li{
  padding: 0 40px;
  font-size: 14px;
  cursor: pointer;
  border-right: 1px solid #fff;
  transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}
.nav li.active,
.nav li:hover{
  color: #fff;
  background: $mainColor;
}

/* 头部 */
.head{
  height: 120px;
  line-height: 120px;
}
.head .logo img{
  width: 120px;
  height: 50px;
  margin-right: 30px;
}
.head h2{
  font-size: 28px;
  color: #444;
}
.head .el-input{
  width: 400px;
}
.head>>>.el-button{
  margin: 0;
}
.head>>>.el-input-group__append{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/App.vue